import { Form } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { Icon, Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.css';

const MandatAnnulationReductionComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group className="panelRow">
					<Form.Input
						data-testid="mandatAnnulationReductionPieceOrigine"
						name="pieceOrigine"
						label={`N° du ${data?.sens === Sens.RECETTE ? 'titre' : 'mandat'} annulé/réduit`}
						value={data?.pieceOrigine ?? ''}
						title={data?.pieceOrigine ?? ''}
						onChange={handleChange}
						width={7}
					/>
					<Form.Input
						data-testid="mandatAnnulationReductionIdLigneOriginePes"
						name="idLigneOriginePes"
						label={`N° de la ligne de ${data?.sens === Sens.RECETTE ? 'titre' : 'mandat'}`}
						value={data?.idLigneOriginePes ?? ''}
						title={data?.idLigneOriginePes ?? ''}
						onChange={handleChange}
						width={7}
					/>
					<Form.Input
						control={Icon}
						name="caret down"
						size="large"
						circular
						width={2}
						className="panelButton"
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default MandatAnnulationReductionComponent;
